import { Link as RouterLink } from 'react-router-dom';
import { Button, ButtonProps, Link as MuiLink } from '@mui/material';
import type { SxProps } from '@mui/system';
import type { Theme } from '@mui/material/styles';
import type { ReactNode, MouseEvent as ReactMouseEvent } from 'react';

type LinkProps = {
  to: string;
  download?: boolean;
  target?: string;
  state?: unknown;
  children: ReactNode;
  color?: string;
  sx?: SxProps<Theme>;
  onClick?: (e: ReactMouseEvent) => void;
};

export const Link = ({ to, children, download, target, state, color, sx, onClick }: LinkProps) => {
  return (
    <MuiLink component={RouterLink} to={to} state={state} download={download} target={target} color={color} sx={sx} onClick={onClick}>
      {children}
    </MuiLink>
  );
};

export const ButtonLink = ({ to, children, download, target, state, buttonProps }: LinkProps & { buttonProps?: ButtonProps }) => {
  return (
    <Button component={RouterLink} to={to} state={state} download={download} target={target} {...buttonProps}>
      {children}
    </Button>
  );
};
